export default {"src":"/_next/static/media/logo_cryptovalley.ec85bfc9.svg","height":31,"width":120,"blurWidth":0,"blurHeight":0};